<template>
  <div class="studyContainer">
    <div style="width:100%;display: flex;justify-content: center;align-items: center;height: 100%;">
      <div class="studyLoginContent">
        <div class="titleLogo">
          <div class="leftLogo"></div>
          <div class="rightCloseIcon">
            <i class="el-icon-close" @click="goBack"></i>
          </div>
        </div>
        <div class="studyTxt">
          学习账号登录
        </div>
        <div class="studyForm">
          <div style="margin-bottom: 20px">
            <el-input v-model="loginForm.username" placeholder="请输入账号"></el-input>
          </div>
          <div>
            <el-input v-model="loginForm.password" placeholder="请输入密码" type="password" show-password></el-input>
          </div>
          <div class="remberPassword">
            <div class="box1" @click="loginForm.remember = !loginForm.remember">
              <div class="iconSelect1" :class="loginForm.remember?'iconSelect1Active':''" >
                <i class="el-icon-check" v-if="loginForm.remember"></i>
              </div>
              <div class="txt">记住密码</div>
            </div>
            <div class="box1" @click="loginForm.isAutoLogin === 1 ? loginForm.isAutoLogin = 0 : loginForm.isAutoLogin = 1">
              <div class="iconSelect1" :class="loginForm.isAutoLogin === 1 ? 'iconSelect1Active' : ''" >
                <i class="el-icon-check" v-if="loginForm.isAutoLogin === 1 "></i>
              </div>
              <div class="txt">保持登录</div>
            </div>
          </div>
        </div>
        <div class="studyLoginBtn">


          <div class="submitBtn" @click="submitMethods">
            登录
          </div>
        </div>
        <div class="tips">
          <div style="width: 100%;display: flex;justify-content: center;align-items: center;height: 100%;">
            登录即表示已阅读并同意《隐私政策》和《服务协议》
          </div>
        </div>
        <div class="footer">
          <div class="keji">
            科技让学习更简单
          </div>
          <div class="goback">
            <span @click="goBack">
              返回首页
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data(){
    return{
      loginForm:{
        username:'W888888',
        password:'W888888',
        remember:true,
        isAutoLogin:1
      }
    }
  },
  mounted() {
  //   判断用户本地是否存储了账号密码
    this.loginForm.username = localStorage.getItem('username') === undefined ? '' : localStorage.getItem('username')
    this.loginForm.password = localStorage.getItem('password') === undefined ? '' : localStorage.getItem('password')
  },
  methods:{
    goBack(){
      this.$router.go(-1);
    },
    submitMethods(){
      if(this.loginForm.userName === '' || this.loginForm.password === ''){
        this.$message.error('账号或密码不能为空');
        return;
      }else{
        this.$axios.post('/loginWithoutCaptcha',this.loginForm).then(res => {
          console.log(res,'登录')
          if(res.code === 200){
            this.loginSuccess(res);
          }else{
            this.$message.error(res.msg);
          }
        }).catch(err => {
          console.log(err);
        })
      }
    },
    loginSuccess(res){
      this.$message.success('登录成功');
      localStorage.setItem('token',res.token);
      // 判断用户是否记住密码
      if(this.loginForm.remember){
        localStorage.setItem('username',this.loginForm.username);
        localStorage.setItem('password',this.loginForm.password);
      }else{
        localStorage.removeItem('username');
        localStorage.removeItem('password');
      }
      
      // 登录成功后初始化并开启背景音乐
      if (this.$musicManager) {
        this.$musicManager.init();
      }
      
      this.$router.push({
        path:'/index/home'
      });
    }
  }
}
</script>
<style scoped lang="scss">
.studyContainer{
  width: 100%;
  height: 100vh;
  background-image: url('@/assets/studyLoginBg-min.png');
  background-size: 100% 100%;
  display: flex;
  justify-items: center;
  align-items: center;





  .studyLoginContent{
    width: 40%;
    height: 510px;
    background-color: #fff;
    border-radius: 5px;
    padding: 20px;

    .titleLogo{
      width: 100%;
      height: 80px;
      display: flex;
      justify-content: space-between;

      .leftLogo{
        width: 150px;
        height: 100%;
        background-image: url("../../../assets/Logo.png");
        background-size: contain;
        background-repeat: no-repeat;
        background-position: center;
      }
      .rightCloseIcon{
        width: 40px;
        height: 100%;
        color: #333333;
        font-size: 26px;
        font-weight: 800;
        display: flex;
        align-items: center;
      }
    }

    .studyTxt{
      width: 100%;
      height: 45px;
      font-size: 20px;
      font-weight: bold;
      letter-spacing: 0px;
      color: #000000;
      padding-left: 25px;

    }

    .studyForm{
      width: 100%;
      height: 160px;
      padding-left: 25px;

      .remberPassword{
        width: 100%;
        height: 30px;
        margin-top: 26px;
        display: flex;

        .box1{
          width: 150px;
          height: 100%;
          display: flex;
          align-items: center;
          cursor: pointer;

          .iconSelect1{
            width: 28px;
            height: 28px;
            border: 1px solid #ccc;
            border-radius: 5px;
            padding: 4px;
          }

          .iconSelect1Active{
            background: #FE8289;
            border: none!important;
            display: flex;
            color: #fff;
            text-align: center;
            align-items: center;
            font-size: 20px;
            font-weight: bold;
          }

          .txt{
            padding-left: 10px;
            color: #393939;
            font-weight: normal;

          }
        }
      }
    }

    .studyLoginBtn{
      width: 100%;
      height: 40px;
      margin-top: 28px;
      color: white;
      cursor: pointer;
      padding-left: 25px;

      .submitBtn{
        width: 100%;background: #3EDDD7;border-radius: 4px;display: flex;justify-content: center;align-items: center;height: 100%;
      }
    }

    .tips{
      width: 100%;
      font-size: 14px;
      margin-top: 15px;
      color: #666666;
      padding-left: 25px;
    }

    .footer{
      width: 100%;
      height: 50px;
      display: flex;
      justify-content: space-between;
      padding-left: 25px;
      margin-top: 40px;
      font-size: 15px;

      .keji{
        width: 60%;
        height: 100%;
        color: #A6A6A6;
      }

      .goback{
        width: 40%;
        height: 100%;
        text-align: right;
        color: #A6A6A6;
        cursor: pointer;
      }
    }
  }


  @media (max-width: 1000px) {
    .studyLoginContent {
      width: 60%;
    }
  }
  @media (min-width: 1001px) and (max-width: 1200px) {
    .studyLoginContent {
      width: 48%;
    }
  }
  @media (min-width: 1400px) {
    .studyLoginContent {
      width: 32.5%;
    }
  }

}
</style>
